<template>
    <div id="map-view">
        <LoadingDots v-if="isLoadingSettings" />
        <ObjectInfo
            v-if="!isLoadingSettings && settings.mod_validation_enable === '1'"
            :open="openInfo"
            :object="activeObject"
            :keys="rightKeys"
            :checkGeom="geom"
            :checkAllKeys="allTags"
            @object-info:dismiss="closeObjectInfo"
            @object-info:waiting="showComment = true"
            @object-info:accept="handleAction('valid')"
            @object-info:reject="handleAction('invalid')"
        />
        <div id="menu" v-if="!isLoadingSettings && settings.mod_validation_enable === '1'">
            <div id="logo"><img src="@/assets/logo.png" /></div>
            <div class="slider-titles">
                <div :class="{ active: activeSlider === 'objects' }" @click="slideTo('objects')">
                    Objets OSM
                </div>
                <div :class="{ active: activeSlider === 'filters' }" @click="slideTo('filters')">
                    Filtres
                </div>
            </div>
            <div class="slider">
                <div class="loading-slide" v-show="isLoadingMenu"><LoadingDots /></div>
                <OsmObjects
                    class="slide-left"
                    :class="{ active: activeSlider === 'objects' }"
                    :key="'objects'"
                    :loading="isLoadingSettings"
                    :themes="filteredOSM"
                    :activeObject="activeObject"
                    @display:object="displayObject"
                    v-model="selected"
                    @osm-objects:waiting="showCommentMany = true"
                    @osm-objects:accept="handleActionMany('valid')"
                    @osm-objects:reject="handleActionMany('invalid')"
                />
                <OsmFilters
                    class="slide-left"
                    :class="{ active: activeSlider === 'filters' }"
                    :key="'filters'"
                    v-model="filters"
                    :vigilances="vigilances"
                    :contributors="contributors"
                    @input="updateMenu()"
                />
            </div>
            <MenuLink></MenuLink>
        </div>
        <OsmMap
            :activeObject="activeObject"
            :overlayOffset="overlayOffset"
            @change:emprise="changeEmprise"
            v-if="!isLoadingSettings && settings.mod_validation_enable === '1'"
            @default:emprise="defaultEmprise"
        />
        <ModalComment
            v-if="showComment && !isLoadingSettings && settings.mod_validation_enable === '1'"
            v-model="comment"
            @dismiss="showComment = false"
            @close="handleComment"
        />
        <ModalComment
            v-if="showCommentMany && !isLoadingSettings && settings.mod_validation_enable === '1'"
            v-model="comment"
            @dismiss="showCommentMany = false"
            @close="handleCommentMany"
        />
    </div>
</template>

<script>
import OsmObjects from '@/components/OsmObjects';
import OsmFilters from '@/components/OsmFilters';
import ObjectInfo from '@/components/map/ObjectInfo';
import ModalComment from '@/components/map/ModalComment';
import OsmMap from '@/components/OsmMap';
import LoadingDots from '@/components/LoadingDots';
import { authenticationService } from '@/services';
import MenuLink from '@/layouts/Menu.vue';
import { Promise } from 'q';

const OVERLAY_WIDTH = 240;

export default {
    data() {
        return {
            activeObject: null,
            rightKeys: [],
            geom: false,
            allTags: false,
            openInfo: false,
            overlayOffset: 0,
            activeSlider: 'objects',
            isLoadingSettings: true,
            isLoadingMenu: false,
            themes: [],
            statuses: null,
            user: authenticationService.currentUserValue,
            showComment: false,
            comment: null,
            filters: {
                vigilance: {},
                contributors: [],
            },
            vigilances: [],
            contributors: [],
            selected: [],
            showCommentMany: false,
            settings: {
                objects_limit: null,
                mod_validation_enable: null,
            },
            loaded_settings: [],
            emprise: null,
        };
    },
    computed: {
        filteredOSM() {
            return this.themes.map((t) => ({
                ...t,
                objects: t.objects.map((o) => ({
                    ...o,
                    osmdiff: o.osmdiff,
                })),
            }));
        },
    },
    updated() {},
    mounted() {
        this.loadSettings();
        if (this.isLoadingSettings) {
            this.isLoadingMenu = true;
            Promise.all([
                //this.$http.get('/api/map/menu', { params: { t: Date.now() }, }),
                this.$http.get('/api/status'),
                // Vigilances pour les filtres
                this.$http.get('/api/vigilance'),
                // Contributeurs pour les filtres
                this.$http.get('/api/contributor'),
            ])
                .then(
                    (responses) => {
                        //this.themes = responses[0].body;
                        this.statuses = responses[0].body;
                        const emptyVigilance = { id: 0, text: 'Tous' };
                        this.vigilances = [
                            emptyVigilance,
                            ...responses[1].body.map((v) => ({
                                id: v.id,
                                text: v.desc_fr,
                            })),
                        ];
                        this.filters.vigilance = emptyVigilance;
                        this.contributors = responses[2].body.map((c) => ({
                            id: c.id,
                            text: c.name,
                        }));
                    },
                    (err) => {
                        // error callback
                        console.log('error loading map', JSON.stringify(err));
                    },
                )
                .finally(() => {
                    this.isLoadingMenu = false;
                });
        }
    },
    methods: {
        updateMenu() {
            this.isLoadingMenu = true;
            const params = {
                t: Date.now(),
                filter: this.getJSONFilter(this.filters),
                footprint: null,
            };
            if (this.emprise && this.emprise.id) {
                params.footprint = this.emprise.id;
            }
            Promise.all([
                this.$http.get('/api/map/menu', {
                    params,
                }),
            ])
                .then(
                    (responses) => {
                        this.themes = responses[0].body;
                    },
                    (err) => {
                        // error callback
                        console.log('error loading map', JSON.stringify(err));
                    },
                )
                .finally(() => (this.isLoadingMenu = false));
        },
        loadSettings() {
            this.isLoadingSettings = true;
            this.$http
                .get('/api/setting')
                .then(
                    (response) => {
                        const settings = response.body;
                        this.loaded_settings = settings;
                        settings.forEach((s) => (this.settings[s.name] = s.value));
                    },
                    (response) => {
                        console.log(JSON.stringify(response));
                    },
                )
                .finally(() => {
                    this.activatedVerif();
                    this.isLoadingSettings = false;
                });
        },

        activatedVerif() {
            if (this.settings.mod_validation_enable !== '1') {
                this.$router.push({ path: '/home' });
            }
        },

        slideTo: function(slider) {
            if (this.activeSlider !== slider) {
                this.closeObjectInfo();
                this.activeSlider = slider;
            }
        },
        displayObject: function(event) {
            const { object, color, checkGeom, checkAllKeys, keys } = event;
            if (this.activeObject && object.id === this.activeObject.id) {
                if (this.openInfo) {
                    this.openInfo = false;
                    this.overlayOffset = 0;
                    this.activeObject = null;
                    this.rightKeys = [];
                    this.geom = false;
                    this.allTags = false;
                    return;
                }
                this.openInfo = true;
                this.overlayOffset = OVERLAY_WIDTH;
                return;
            }
            this.activeObject = {
                ...object,
                color: color || '#378fbd',
            };
            this.geom = checkGeom;
            this.allTags = checkAllKeys;
            this.rightKeys = keys;
            this.openInfo = true;
            this.overlayOffset = OVERLAY_WIDTH;
        },
        closeObjectInfo: function() {
            this.openInfo = false;
            this.overlayOffset = 0;
        },
        createValidation: function(object, statusName, comment = null) {
            const status = this.statuses.find((s) => s.name === statusName);

            let footprint;
            if (this.emprise && this.emprise.id) {
                footprint = this.emprise.id;
            }

            return this.$http.post('/api/validation', {
                user: this.user,
                status,
                object,
                comment,
                footprint: footprint,
                version: object.version,
            });
        },
        handleComment: function() {
            this.createValidation(this.activeObject, 'waiting', this.comment).then(
                ({ body }) => {
                    this.showComment = false;
                    this.comment = null;
                    this.activeObject.validations.push(body);
                    this.updateObject(body);
                },
                (err) => {
                    console.log('error create validation', JSON.stringify(err));
                },
            );
        },
        handleAction: function(status) {
            this.createValidation(this.activeObject, status).then(
                ({ body }) => {
                    this.removeObject(body);
                    this.updateMenu();
                },
                (err) => {
                    console.log('error create validation', JSON.stringify(err));
                },
            );
        },
        updateObject: function(validation) {
            this.themes = this.themes.map((t) => ({
                ...t,
                objects: t.objects.map((o) => ({
                    ...o,
                    osmdiff: o.osmdiff.map((osm) => {
                        if (osm.id !== validation.object.id) {
                            return osm;
                        }
                        return {
                            ...osm,
                            validations: [].concat(osm.validations, [validation]),
                        };
                    }),
                })),
            }));
        },
        removeObject: function(validation) {
            this.themes = this.themes.map((t) => ({
                ...t,
                objects: t.objects.map((o) => ({
                    ...o,
                    osmdiff: o.osmdiff.filter((osm) => osm.id !== validation.object.id),
                })),
            }));
            this.closeObjectInfo();
            this.activeObject = null;
        },
        // validate: function(validation) {
        //     return this.$http.post('/api/validation', validation);
        // .then(
        //     ({ body }) => {
        //         this.showComment = false;
        //         this.comment = null;
        //         this.activeObject.validations.push(body);
        //         this.updateThemes(body, hold);
        //     },
        //     (err) => {
        //         // error callback
        //         console.log('error create validation', JSON.stringify(err));
        //     },
        // );
        // },
        handleCommentMany: function() {
            Promise.all(
                this.selected.map((object) =>
                    this.createValidation(object, 'waiting', this.comment),
                ),
            ).then(
                (responses) => {
                    this.showCommentMany = false;
                    this.comment = null;
                    responses.forEach((r) => this.updateObject(r.body));
                },
                (err) => {
                    // error callback
                    console.log('error create validation', JSON.stringify(err));
                },

                // Efface la sélection une fois traitée
                (this.selected = []),
            );
        },
        handleActionMany: function(status) {
            this.closeObjectInfo();
            this.activeObject = null;
            this.isLoadingMenu = true;
            Promise.all(this.selected.map((object) => this.createValidation(object, status))).then(
                () => {
                    this.actionCounter = this.actionCounter - 1;
                    this.updateMenu();
                },
                (err) => {
                    // error callback
                    console.log('error create validation', JSON.stringify(err));
                },

                // Efface la sélection une fois traitée
                (this.selected = []),
            );
        },
        getJSONFilter: function(filters) {
            const jsonFilter = {};
            // Contributeurs
            if (filters && filters.contributors && filters.contributors.length) {
                jsonFilter.contributors = [];
                for (let i = 0; i < filters.contributors.length; i++) {
                    const contributor = filters.contributors[i];
                    if (contributor.id && contributor.text) {
                        jsonFilter.contributors.push({
                            id: contributor.id,
                            text: contributor.text,
                        });
                    }
                }
            }
            // Types de contributeurs
            if (filters && filters.vigilance && filters.vigilance.id) {
                jsonFilter.vigilance = {
                    id: filters.vigilance.id,
                    text: filters.vigilance.text,
                };
            }
            return JSON.stringify(jsonFilter);
        },
        changeEmprise: function(emprise) {
            this.emprise = emprise;
            this.updateMenu();
            this.closeObjectInfo();
        },
        defaultEmprise: function(emprise) {
            this.emprise = emprise;
            this.updateMenu();
            this.closeObjectInfo();
        },
    },
    components: {
        OsmObjects,
        OsmFilters,
        OsmMap,
        ObjectInfo,
        ModalComment,
        LoadingDots,
        MenuLink,
    },
};
</script>

<style lang="scss">
$menu-width: 240px;

.slide-left {
    transition: all 0.25s ease-in-out;
    transform: translateX(20px);
    opacity: 0;
    z-index: 0;

    &.active {
        transition: all 0.5s ease-in-out;
        transform: translateX(0px);
        opacity: 1;
        z-index: 1;
        overflow-x: hidden;
    }
}

.slide {
    position: absolute;
    height: 100%;
    // position: fixed;
    overflow-y: auto;
    width: $menu-width;
    // top: 0;
    /*scrollbar-color: #6c3e91 #fff;*/
}

.loading-slide {
    position: absolute;
    height: 100%;
    z-index: 9;
    width: 100%;
    background-color: rgba(255, 255, 255, 0.6);
    padding-top: 50%;
}

#map-view {
    display: flex;
    flex-direction: row;

    #menu {
        width: $menu-width;
        background-color: #ffffff;
        display: flex;
        flex: 1;
        flex-direction: column;
        justify-content: flex-start;
        height: 100vh;
        z-index: 2000;
        border-right: solid #6c3e91 1px;

        #logo {
            width: $menu-width;
            height: 50px;
            background-color: #6c3e91;
            flex-shrink: 0;
            flex-grow: 0;
            flex-basis: 50px;

            display: flex;
            flex-direction: column;
            justify-content: center;

            > img {
                margin-left: 20px;
                display: block;
                max-width: 115px;
                height: auto;
            }
        }

        .slider-titles {
            display: flex;
            flex-direction: row;
            color: #9ca5b0;
            justify-content: space-between;
            font-weight: 600;
            padding: 0 46px;

            > div {
                padding: 16px 0;
                cursor: pointer;
            }

            > div.active {
                color: #2a2a2a;
                border-bottom: solid 3px #6c3e91;
                padding-bottom: 13px;
            }

            flex-shrink: 0;
            flex-grow: 0;
        }

        .slider {
            flex-grow: 1;
            flex-shrink: 1;
            // width: 100%;

            overflow: hidden;
            position: relative;
        }
    }
}
</style>
